export default __webpack_public_path__ + "static/media/bazzle_m_1.4620ec3b.png";